import * as React from 'react'
import PropTypes from 'prop-types'
import Badge from "../Badge"

// constants
import { phaseShortcutMap } from 'containers/studies/Study/subcomponents/Authoring/RJS/schemas/dataSchemas/enum/enum'

const PhaseBadge = ({ value }) => {
  if (!value || value === "N/A") return null;

  return <Badge
    value={phaseShortcutMap?.[value]}
    tooltipText={value}
    colorName="charcoal"
    style={{ width: 50 }}
  />
}

export default PhaseBadge

PhaseBadge.propTypes = {
  value: PropTypes.oneOf(Object.keys(phaseShortcutMap)),
}